import Vue from 'vue'
import Vuex from 'vuex'
import { logout } from '@/api/auth'
import { removeToken } from '@/utils/request'
import { getRouterList, removeRouterList } from '@/utils/permission'
import { getRegionTree } from '@/api/common'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      id: null,
      name: '',
      nickname: '',
      role: '',
      routerList: getRouterList()  // 刷新页面后从 localStorage 恢复
    },
    notificationCount: 0,

    /** 属地级联数据（全局缓存，只请求一次） */
    regionOptions: [],
    regionOptionsLoading: false
  },

  getters: {
    userName: state => state.user.nickname || state.user.name || '管理员',
    userRole: state => state.user.role,
    notificationCount: state => state.notificationCount,
    regionOptions: state => state.regionOptions
  },

  mutations: {
    SET_USER(state, user) {
      state.user = { ...state.user, ...user }
    },
    RESET_USER(state) {
      state.user = { id: null, name: '', nickname: '', role: '', routerList: [] }
    },
    SET_NOTIFICATION_COUNT(state, count) {
      state.notificationCount = count
    },
    SET_REGION_OPTIONS(state, list) {
      state.regionOptions = list
    },
    SET_REGION_LOADING(state, val) {
      state.regionOptionsLoading = val
    },
    CLEAR_REGION_OPTIONS(state) {
      state.regionOptions = []
      state.regionOptionsLoading = false
    }
  },

  actions: {
    /** 登录成功后写入用户信息 */
    setUserInfo({ commit }, userInfo) {
      commit('SET_USER', {
        id: userInfo.userId,
        name: userInfo.username,
        nickname: userInfo.nickname || userInfo.username,
        role: userInfo.role || '',
        routerList: userInfo.routerList || []
      })
    },

    /** 退出：调接口 → 清 cookie → 清 store（含 regionOptions 缓存） */
    logout({ commit }) {
      return logout()
        .catch(() => {})
        .finally(() => {
          removeToken()
          removeRouterList()
          commit('RESET_USER')
          commit('CLEAR_REGION_OPTIONS')
        })
    },

    /**
     * 懒加载属地数据：已缓存或请求中则直接返回，避免重复请求
     * 所有页面统一调用此 action，不再各自请求
     */
    fetchRegionOptions({ state, commit }) {
      if (state.regionOptions.length > 0 || state.regionOptionsLoading) {
        return Promise.resolve()
      }
      commit('SET_REGION_LOADING', true)
      return getRegionTree().then(res => {
        const options = (res.data || []).map(city => ({
          value: city.name,
          label: city.name,
          children: (city.children || []).map(district => ({
            value: district.name,
            label: district.name
          }))
        }))
        commit('SET_REGION_OPTIONS', options)
      }).catch(() => {}).finally(() => {
        commit('SET_REGION_LOADING', false)
      })
    }
  },

  modules: {}
})
